import React from "react";
import { Navigate } from "react-router-dom";
// import Storage from "";
import GetStorage from "../services/storage";
import storage from "../services/storage";
const ProtectedRoutes = ({ children }) => {
  const user = GetStorage.get("xAuthToken");
  if (!user) {
    storage.store("redirectedURlBeforeAccess", window?.location?.pathname);
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoutes;
